<template>
	<div>
		<!-- <h4>Time Entries.</h4> -->


		<div>

			<vx-card title="Daily Hours" class="mb-5">

				<div class="flex">
					
					<flat-pickr :config="configFromdateTimePicker" v-model="fromDate" placeholder="From Date" @on-change="onFromChange" />
					<span class="ml-2 mt-2">-</span>
					<flat-pickr :config="configTodateTimePicker" v-model="toDate" placeholder="To Date" @on-change="onToChange" class="ml-3"/> 
					
					
					<vs-switch color="primary" v-model="sortByClients" class="ml-4 mt-2">
						<span slot="on">Clients</span>
						<span slot="off">Workers</span>
					</vs-switch>

					<vs-switch color="primary" v-model="sortByHours" class="ml-4 mt-2">
						<span slot="on">Hours</span>
						<span slot="off">Name</span>
					</vs-switch>

					<vs-switch color="primary" v-model="sortAscending" class="ml-4 mt-2">
						<span slot="on">Desc</span>
						<span slot="off">Asc</span>
					</vs-switch>


				</div>

        
				<vs-list class="mt-5">

					<vs-list-item :title="item.WorkerName" :subtitle="item.TotalHours.toFixed(1) + ' Hours'" v-for="item in StatsHoursSorted()" class="dailyTimeWorkerListItem">
						
						<template slot="avatar">
						<vs-avatar :src="item.Avatar" size="large" class="mr-3"/>
						</template>
						
						<vs-list-item :title="client.ClientName" :subtitle="client.TotalHours.toFixed(1) + ' Hours'" v-for="client in item.Clients" class="dailyTimeClientListItem">
							
							<template slot="avatar" v-if="!sortByClients">
								<vs-avatar :src="client.Avatar"/>
							</template>
							
							<div class="ml-12">
								<vs-list-item :title="category.CategoryName" :subtitle="category.TotalHours.toFixed(1) + ' Hours'" v-for="category in client.Categories" class="dailyTimeCategoryListItem">
									<template slot="avatar" v-if="sortByClients">
										<vs-avatar :src="category.Avatar"/>
									</template>
								</vs-list-item>
							</div>


						</vs-list-item>

					</vs-list-item>


				</vs-list>


			</vx-card>


		</div>

	</div>
</template>


<script>

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'vue-select/dist/vue-select.css'
const moment = require('moment')


export default{
  components:{
    flatPickr,
    'v-select': vSelect
  },
  data () {
    return {
      selectedTimeEntry 	: null,
      workerSwitch		: false,
      selectedWorkerID	: -1,
      sortByClients		: false,
      sortByHours			: false,
      sortAscending		: false,
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      configFromdateTimePicker: {
        minDate: null,
        maxDate: null
      },
      configTodateTimePicker: {
        minDate: null
      }

    }
  },
  computed:{
    userLoggedIn () {
      return this.$store.getters.GetUserLoggedIn
    },
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    timeEntryList () {
      const list = this.$store.getters.GetTimeEntryList
      if (this.selectedWorkerID != -1) { //Selecting a certain worker
        return list.filter(x => x.WorkerID == this.selectedWorkerID)
      } else { //Selecting all wrkers
        return list
      }
    },
    categoryList () {
      return this.$store.getters.GetCategoryList
    },
    clientList () {
      return this.$store.getters.GetClientListAll
    },
    taskList () {
      return this.$store.getters.GetTaskList
    },
    projectList () {
      return this.$store.getters.GetProjectList
    },
    workerList () {
      return this.$store.getters.GetWorkerList
    },
    workerListAndAll () {
      const workers = []
      workers.push({'WorkerID': -1, 'WorkerName': 'All'})
      for (let i = 0; i < this.workerList.length; i++) {
        workers.push({'WorkerID': this.workerList[i].WorkerID, 'WorkerName': this.workerList[i].WorkerName})
      }
      return workers
    },
    activeUserInfo () {
      return this.$store.getters.AppActiveUser
    },
    workerID () {
      return this.$store.getters.GetWorkerID
    },
    statsHoursRaw () {
      return this.$store.getters.GetStatsHours
    }
		
  },
  watch : {
    userLoggedIn (loggedIn) {
      if (loggedIn) {
        this.OnLoggedIn()
      }
    }
  },
  methods: {
    statsHours () {
      const stats = this.statsHoursRaw
      for (let i = 0; i < stats.length; i++) {
        const stat = stats[i]
        stats[i].ClientName = this.GetClientByID(stat.ClientID).ClientName
        stats[i].CategoryName = this.GetCategoryByID(stat.CategoryID).CategoryName
      }
      return stats
    },
    onFromChange (selectedDates, dateStr, instance) {
      //this.$set(this.configTodateTimePicker, 'minDate', dateStr);
      this.GetStatsHours()
    },
    onToChange (selectedDates, dateStr, instance) {
      //this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
      this.GetStatsHours()
      	},
    StatsHoursSorted () {
      if (this.sortByClients) {
        return this.StatsHoursSortedByClient()
      } else {
        return this.StatsHoursSortedByName()
      }
    },
    StatsHoursSortedByClient () {
      const stats = this.statsHours()
		
      const statsObject = []

      for (var i = 0; i < stats.length; i++) {
        var stat = stats[i]

        let workerIndex = statsObject.findIndex(x => x.WorkerName == stat.ClientName)
				
        //Worker not registered yet
        if (workerIndex == -1) {
          statsObject.push({
            WorkerName: stat.ClientName,
            Avatar: this.GetClientAvatar(stat.ClientID),
            TotalHours: 0,
            Clients: []
          })
          workerIndex = statsObject.length - 1
        }
				

        let clientIndex = statsObject[workerIndex].Clients.findIndex(x => x.ClientName == stat.CategoryName)

        //Client not registered yet
        if (clientIndex == -1) {
          statsObject[workerIndex].Clients.push({
            ClientName: stat.CategoryName,
            TotalHours: 0,
            Categories: []
          })
          clientIndex = statsObject[workerIndex].Clients.length - 1
        }
				

        statsObject[workerIndex].Clients[clientIndex].Categories.push({
          CategoryName: stat.WorkerName,
          TotalHours: stat.HoursWorked || 0,
          Avatar: this.GetWorkerAvatar(stat.WorkerID)
        })

        statsObject[workerIndex].TotalHours += stat.HoursWorked || 0
        statsObject[workerIndex].Clients[clientIndex].TotalHours += stat.HoursWorked || 0
      }

      statsObject.sort(this.CompareWorkerObject)

      for (var i = 0; i < statsObject.length; i++) {
        statsObject[i].Clients.sort(this.CompareClientObject)
        for (let c = 0; c < statsObject[i].Clients.length; c++) {
          statsObject[i].Clients[c].Categories.sort(this.CompareCategoryObject)
        }
      }
      return statsObject
		
    },
    StatsHoursSortedByName () {
      const stats = this.statsHours()
		
      const statsObject = []

      for (var i = 0; i < stats.length; i++) {
        var stat = stats[i]


        let workerIndex = statsObject.findIndex(x => x.WorkerName == stat.WorkerName)
				
        //Worker not registered yet
        if (workerIndex == -1) {
          statsObject.push({
            WorkerName: stat.WorkerName,
            Avatar: this.GetWorkerAvatar(stat.WorkerID),
            TotalHours: 0,
            Clients: []
          })
          workerIndex = statsObject.length - 1
        }
				

        let clientIndex = statsObject[workerIndex].Clients.findIndex(x => x.ClientName == stat.ClientName)

        //Client not registered yet
        if (clientIndex == -1) {
          statsObject[workerIndex].Clients.push({
            ClientName: stat.ClientName,
            TotalHours: 0,
            Categories: [],
            Avatar: this.GetClientAvatar(stat.ClientID)
          })
          clientIndex = statsObject[workerIndex].Clients.length - 1
        }
				

        statsObject[workerIndex].Clients[clientIndex].Categories.push({
          CategoryName: stat.CategoryName,
          TotalHours: stat.HoursWorked || 0
        })

        statsObject[workerIndex].TotalHours += stat.HoursWorked || 0
        statsObject[workerIndex].Clients[clientIndex].TotalHours += stat.HoursWorked || 0
      }

      statsObject.sort(this.CompareWorkerObject)

      for (var i = 0; i < statsObject.length; i++) {
        statsObject[i].Clients.sort(this.CompareClientObject)
        for (let c = 0; c < statsObject[i].Clients.length; c++) {
          statsObject[i].Clients[c].Categories.sort(this.CompareCategoryObject)
        }
      }

      return statsObject
		
    },
    GetABCVal () {
      return this.sortAscending ? -1 : 1
    },
    CompareWorkerObject (a, b) {

      if (this.sortByHours) {
        return (b.TotalHours > a.TotalHours ? 1 : -1) * this.GetABCVal()
      }

      const bandA = a.WorkerName.toUpperCase()
      const bandB = b.WorkerName.toUpperCase()

      let comparison = 0
      if (bandA > bandB) {
        comparison = 1
      } else if (bandA < bandB) {
        comparison = -1
      }
      return comparison * this.GetABCVal()
    },
    CompareClientObject (a, b) {

      if (this.sortByHours) {
        return (b.TotalHours > a.TotalHours ? 1 : -1) * this.GetABCVal()
      }

      const bandA = a.ClientName.toUpperCase()
      const bandB = b.ClientName.toUpperCase()

      let comparison = 0
      if (bandA > bandB) {
        comparison = 1
      } else if (bandA < bandB) {
        comparison = -1
      }
      return comparison * this.GetABCVal()
    },
    CompareCategoryObject (a, b) {

      if (this.sortByHours) {
        return (b.TotalHours > a.TotalHours ? 1 : -1) * this.GetABCVal()
      }

      const bandA = a.CategoryName.toUpperCase()
      const bandB = b.CategoryName.toUpperCase()

      let comparison = 0
      if (bandA > bandB) {
        comparison = 1
      } else if (bandA < bandB) {
        comparison = -1
      }
      return comparison * this.GetABCVal()
    },	
		
    OnLoggedIn () {

      const startDay = moment()
      const day = startDay.day()
      let diff = 1  // returns yesterday
      if (day == 0 || day == 1) {  // is Sunday or Monday
        diff = day + 2  // returns Friday
      }
			 startDay.subtract(diff, 'days')

      if (startDay.day() == 5) { //Last work day was friday
        this.fromDate = startDay.format('YYYY-MM-DD')
        this.toDate = moment().format('YYYY-MM-DD')
      } else {
        this.fromDate = startDay.format('YYYY-MM-DD')
        this.toDate = startDay.format('YYYY-MM-DD')
      }

      this.GetStatsHours()
    },
    GetStatsHours () {
      if (moment(this.fromDate, 'YYYY-MM-DD').isSameOrBefore(moment(this.toDate, 'YYYY-MM-DD'))) {
        const payload = {
          startDate: moment(`${this.fromDate  } 5:01 AM`, 'YYYY-MM-DD hh:mm A').utc().add(1, "hours").format(),
          endDate: moment(`${this.toDate  } 11:59 PM`, 'YYYY-MM-DD hh:mm A').utc().add(1, "hours").format()
        }
        this.$store.dispatch('ActionFetchStatsHours', payload)
      } else {
        this.$store.commit('SetStatsHours', [])

      }
    },
    OnChangedWorker () {
      if (this.selectedWorkerID == null) {
        this.selectedWorkerID = -1
      }
    },
    GetClientFromName (id) {
      if (this.clientList == null) return null
      const client = this.clientList.find(x => x.ClientID == id)
      return client || null
    },
    GetClientAvatar (name) {
      const client = this.GetClientFromName(name)
      if (client == null) return null
      return client.ClientAvatar
    },
    GetWorkerAvatar (workerID) {
      const worker = this.GetWorkerFromID(workerID)
      if (worker == null) return null

      return worker.WorkerAvatar
    },
    GetWorkerFromID (workerID) {
      if (this.workerList == null) return null
      return this.workerList.find(x => x.WorkerID == workerID) || null
    },
    WorkerNameFromID (id) {
      if (this.workerList == null) return ''
      const worker = this.workerList.find(x => x.WorkerID == id)
      if (worker == null) return ''
      return worker.WorkerName
    },
    HandleSelectedTimeEntry (timeEntry) {
			
      this.$store.dispatch('ActionFetchTimeEntry', timeEntry.RecordID.toString()).then(response => {
        const data = response.data
        this.$store.dispatch('ActionSetTimeEntryPrompt', {
          active: true,
          title: 'Edit Existing Time Entry',
          recordID: data.RecordID,
          clientID: data.ClientID,
          categoryID: data.CategoryID,
          taskID: data.TaskID,
          startTime: moment(data.TimeIn, 'YYYY-MM-DD hh:mm A').format('hh:mm A'),
          startDate: moment(data.TimeIn, 'YYYY-MM-DD hh:mm A').format('Y-MM-DD'),
          endTime: moment(data.TimeOut, 'YYYY-MM-DD hh:mm A').format('hh:mm A'),
        			endDate: moment(data.TimeOut, 'YYYY-MM-DD hh:mm A').format('Y-MM-DD'),
          description: data.Note,
          action: 'edit', //create, edit, finish
          mileage: data.Mileage,
          sowID: data.SOWID,
          sowLineItemID: data.SOWLineItemID
        })

      })

    },
    GetClientByID (clientID) {
      const def = {ClientName:'None'}
      if (this.clientList == null) return def
      const client = this.clientList.find(x => x.ClientID == clientID)
      if (client == null) return def
      return client
    },
    GetProjectByID (taskID) {
      const task = this.GetTaskByID(taskID)
      if (task.Task == 'None') {
        return {ProjectName:'None'}
      }
      let project = this.projectList.find(x => x.ProjectID == task.ProjectID)
      if (project == null) {
        project = {ProjectName:'None'}
      } else if (project.ProjectName == '' || project.ProjectName == null) {
        project = {ProjectName:'None'}
      }
			
      return project
    },
    GetProjectByCategoryID (categoryID) {
      let project = this.projectList.find(x => x.CategoryID == categoryID)
      if (project == null) {
        project = {ProjectName:'None'}
      } else if (project.ProjectName == '' || project.ProjectName == null) {
        project = {ProjectName:'None'}
      }
			
      return project
    },
    GetTaskByID (taskID) {
      let task = this.taskList.find(x => x.TaskID == taskID)
      if (task == null) {
        task = {Task:'None'}
      } else if (task.Task == '' || task.Task == null) {
        task = {Task:'None'}
      }
			
      return task
    },
    GetCategoryByID (categoryID) {
      let category = this.categoryList.find(x => x.CategoryID == categoryID)
      if (category == null) category = {CategoryName : 'None'}

      return category
    },
    BeginCreatingNewEntry () {
      const currentTime = moment().format('hh:mm A')
      const currentDate = moment().format('Y-MM-DD')
      this.$store.dispatch('ActionSetTimeEntryPrompt', {
        active: true,
        title: 'Create New Time Entry',
        taskName: '',
        clientID: null,
        taskID: null,
        projectID: null,
        categoryID: null,
        startTime: currentTime,
        endTime: currentTime,
        startDate: currentDate,
        endDate: currentDate,
        description: '',
        error: 'Fields cannot be empty.',
        action: 'create', //create, edit, finish
        mileage: 0,
        sowID: null,
        sowLineItemID: null
      })
    },
    GetDateDay (s) {
      return moment(s, 'YYYY-MM-DD hh:mm A').format('M/DD')
    },
    GetDateTimes (s, e) {
      const format = 'YYYY-MM-DD hh:mm A'
      return `${moment(s, format).format('h:mm A')  } - ${  moment(e, format).format('h:mm A')}` 
    },
    GetTimeDif (s, e) {
      const format = 'YYYY-MM-DD hh:mm A'

      const ms = moment(e, format).diff(moment(s, format))
      const d = moment.duration(ms)
      const p = Math.floor(d.asHours()) + moment.utc(ms).format(':mm')

      return p

    }
  },
  mounted () {
    if (this.userLoggedIn) {
      this.OnLoggedIn()
    }
  }
}

</script>

